var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import AccountUtils from '@popup/steem/utils/account.utils';
const TIME_REFERENCE = 1643236071000;
export const refreshActiveAccount = () => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const delay = Math.min(((Date.now() - TIME_REFERENCE) % 3) * 1000 + 100, 3000);
    setTimeout(() => {
        const account = getState().steem.accounts.find((localAccount) => localAccount.name === getState().steem.activeAccount.name);
        dispatch(loadActiveAccount(account));
    }, delay);
});
export const refreshKeys = (localAccount) => {
    return {
        type: SteemActionType.SET_ACTIVE_ACCOUNT,
        payload: {
            keys: localAccount.keys,
        },
    };
};
export const loadActiveAccount = (account) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (account &&
        getState().steem.activeRpc &&
        ((_a = getState().steem.activeRpc) === null || _a === void 0 ? void 0 : _a.uri) !== 'NULL') {
        dispatch(refreshKeys(account));
        dispatch(getAccountRC(account.name));
        const extendedAccount = yield AccountUtils.getExtendedAccount(account.name);
        dispatch({
            type: SteemActionType.SET_ACTIVE_ACCOUNT,
            payload: {
                account: extendedAccount,
                name: account.name,
            },
        });
    }
});
export const getAccountRC = (username) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const rc = yield AccountUtils.getRCMana(username);
    dispatch({
        type: SteemActionType.SET_ACTIVE_ACCOUNT_RC,
        payload: rc,
    });
});
export const resetActiveAccount = () => {
    return {
        type: SteemActionType.RESET_ACTIVE_ACCOUNT,
    };
};
